import { BrowserRouter, Routes, Route } from "react-router-dom";
import { OpenApp } from "./pages/OpenApp";
import { AppOpenPage } from "./pages/AppOpenPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppOpenPage />} />
        <Route path="/product/:sku" element={<OpenApp />} />
        <Route path="/category/:categoryName" element={<AppOpenPage />} />
        <Route path="/category/:categoryName/:subcategoryName" element={<AppOpenPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;